'use client';

import type { SDSInternalLinkProps } from '@repo/sds/components/_internal/SDSInternalLink/types';
import { useSDSConfig } from '@repo/sds/providers/SDSProvider';

/**
 * Internal link component that uses the configured link component from SDSProvider
 *
 * This component is used internally by SDSLink for internal navigation.
 * External links are handled by SDSLink before reaching this component.
 *
 * The linkComponent provided to SDSProvider MUST accept an 'href' prop.
 * For React Router apps, use an adapter component that converts href to 'to'.
 */
export const SDSInternalLink = ({ href, children, ...props }: SDSInternalLinkProps) => {
  const { linkComponent: LinkComponent } = useSDSConfig();

  return (
    <LinkComponent href={href} {...props}>
      {children}
    </LinkComponent>
  );
};
